import { proxy } from 'valtio'

type LocationPinAtom = {
  pins: Partial<Record<uui.domain.ui.map.LocationPinId, uui.domain.ui.map.LocationPin>>
}

export const locationPin = proxy<LocationPinAtom>({ pins: {} })
